import { createQueryData } from '../helpers/createQueryData';
import { useInvalidate } from '../helpers/useInvalidate';

const endPoint = 'Acceptance/acceptance_view_info';

const { useQuery, createKey: createAcceptanceViewInfoKey } = createQueryData({
  endPoint,
});

const useAcceptanceViewInfoQuery = ({
  params: { serviceCompanyId } = {},
  options,
} = {}) =>
  useQuery({
    params: { serviceCompanyId },
    options: {
      enabled: Boolean(serviceCompanyId),
      staleTime: 1000 * 60,
      ...options,
    },
  });

const useAcceptanceViewInfoInvalidate = () => useInvalidate([endPoint]);

export {
  useAcceptanceViewInfoQuery,
  createAcceptanceViewInfoKey,
  useAcceptanceViewInfoInvalidate,
};
